import React from 'react';
import PropTypes from 'prop-types';
import './ConfirmationModal.scss';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  payload,
  setPayload,
  title,
  message,
  confirmText,
  cancelText,
  link
}) => {
  if (!isOpen) return null;

  const handleTncChange = (e) => {
    setPayload({ ...payload, is_tnc_accepted: e.target.checked });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
        <p className="mb-4">{message}</p>
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={payload.is_tnc_accepted}
              onChange={handleTncChange}
              className="mr-2"
            />
            <span>I accept the <a href={link}>terms and conditions</a></span>
          </label>
        </div>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={!payload.is_tnc_accepted}
            className={`px-4 py-2 rounded text-white ${
              payload.is_tnc_accepted
                ? 'bg-blue-500 hover:bg-blue-600'
                : 'bg-gray-400 cursor-not-allowed'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};

ConfirmationModal.defaultProps = {
  title: 'Confirmation',
  message: 'Are you sure you want to proceed?',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
};

export default ConfirmationModal;